
ADILF.define('adilf/context',['require','exports','module','streamhub-sdk/jquery','adilf/debug'],function (require, exports, module) {/* Common: ADI Context
Context means:
    - Affiliate
    - Entry meta data (if applicable)
    - LF Site ID (?)
    - LF Network ID (?)
    - LF Environment (production, integration)
    - ADI authentication tier (production, uat, stage, dev) */
"use strict";

var jquery = require('streamhub-sdk/jquery');
var Debug = require('adilf/debug');

var _instance = null;

var _getInstance = function() {
    if (!_instance) {
        _instance = new Context();
    }
    return _instance;
};

var Context = function() {
    var self = this;
    /* istanbul ignore next */
    if (_instance !== null) {
        return;
    }
    _init.call(self);
};

Context.prototype.debug = new Debug("Context");

var _init = function(args) {
    var self = this;
    args = args || {};
    args.uri = args.uri || window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    args.LF_META = args.LF_META || window.LF_META;
    _setTier.call(self, args);
    _setAffiliate.call(self, args);
    _setPage.call(self, args);
    self.debug.print("Initialized", self);
};

Context.prototype.reset = function(args) {
    var self = this;
    self.debug.print("Resetting with args:", args);
    _init.call(self, args);
};

// name, envSuffix, lf.networkId, lf.jsDomain, lf.env
Context.prototype.getTier = function() {
    return this.tier;
};

Context.prototype.getPage = function() {
    return this.page;
};

Context.prototype.getAffiliate = function() {
    return this.affiliate;
};

Context.prototype.getSiteId = function(cms) {
    cms = cms || this.page.cms;
    return this.affiliate.siteIds[cms];
};

Context.prototype.getNetworkId = function() {
    return this.tier.lf.networkId;
};

Context.prototype.getEnvironmentId = function() {
    return this.tier.lf.environmentId;
};

Context.prototype.getTLD = function(link) {
    link = link.split("/")[2] || /* istanbul ignore next */ window.location.host;
    var h = (link).split(".").reverse();
    return [ h[1], h[0] ].join(".");
};

Context.prototype.getInstance = _getInstance;

/* Hierarchy:
1. args.networkId
2. LF_META
3. uri
    3a. Maybe adapt to consider window.advEnvPrefix instead?  Requires applications to provide an accurate value, which they don't.
*/
var _setTier = function(args) {
    var self = this;
    args.LF_META = args.LF_META|| {};
    // If networkId is explicitly provided it takes priority
    var networkId = args.networkId || args.LF_META.networkId;
    var tier = _network2tier(networkId);
    // If networkId is not explicitly provided -- uri may come in as a param, otherwise defaults to window.location.href
    if(!tier) {
        var subdomain = args.uri.split('/')[2];
        if (subdomain.match(/(uat|stage)/g)) {
            tier = "uat";
        } else if (subdomain.match(/(dev|localhost)/g)) {
            tier = "dev";
        } else {
            tier = "production";
        }
    }
    self.tier = _tiers[tier];
    self.tier.name = tier;
    self.tier.mt = {
        "advEnvPrefix": (window.advEnvPrefix) ? window.advEnvPrefix : self.tier.envSuffix
    };
    if(self.tier.mt.advEnvPrefix != self.tier.envSuffix && window.console) {
        self.debug.warn("advEnvPrefix '" + self.tier.mt.advEnvPrefix + "' does not match Livefyre authentication tier '" + self.tier.envSuffix +"' - auth may not work");
    }
};

// username, permalink, title, LF_META.stuff, cms
var _setPage = function(args) {
    args = args || /* istanbul ignore next */ {};
    var self = this;
    var module = (args.module) ? args.module : (self.page && self.page.module) ? self.page.module : null; // retain 'module'
    self.page = {
        "permalink": args.uri,
        "title": window.m_entry_title || window.document.title,
        "LF_META": jquery.extend({}, args.LF_META),
        "cms": (args.uri.match(/highschoolsports/)) ? "hssn" : "default",
        "module": module
    };
};

// name, marketingName, tz, domain, siteIds.default, siteIds.hssn
var _setAffiliate = function(args) {
    var self = this;
    var tld = this.getTLD(args.uri);
    if(_affs.hasOwnProperty(tld)) {
        self.affiliate = _affs[tld];
        self.affiliate.domain = tld;
    } else {
        // local development
        self.affiliate = _affs["advance.net"];
        self.affiliate.domain = "advance.net";
    }
    self.affiliate.siteIds = _siteIds[self.tier.name][self.affiliate.domain];
};

// :(
var _network2tier = function(networkId) {
    var map = {
        'advancedigital-int-0.fyre.co': 'dev',
        'advancedigital-uat.fyre.co': 'uat',
        'advancedigital.fyre.co': 'production'   
    };
    return map[networkId];
};

var _tiers = {
    "production": {
        "envSuffix": "",
        "lf": {
            "networkId": "advancedigital.fyre.co",
            "jsDomain": "zor.livefyre.com",
            "env": "production",
            "environmentId": "livefyre.com"
        }
    },
    "uat": {
        "envSuffix": "-uat",
        "lf": {
            "networkId": "advancedigital-uat.fyre.co",
            "jsDomain": "zor.livefyre.com",
            "env": "production",
            "environmentId": "livefyre.com"
        }
    },
    "dev": {
        "envSuffix": "-dev",
        "lf": {
            "networkId": "advancedigital-int-0.fyre.co",
            "jsDomain": "zor.t402.livefyre.com",
            "env": "integration",
            "environmentId": "t402.livefyre.com"
        }
    }
};

var _affs = {
    "al.com": {
        "name": "bama",
        "marketingName": "AL.com",
        "tz": "CST"
    },
    "cleveland.com": {
        "name": "cleve",
        "marketingName": "cleveland.com",
        "tz": "EST"
    },
    "gulflive.com": {
        "name": "gulf",
        "marketingName": "GulfLive.com",
        "tz": "CST"
    },
    "lehighvalleylive.com": {
        "name": "lvlive",
        "marketingName": "lehighvalleylive.com",
        "tz": "EST"
    },
    "mardigras.com": {
        "name": "mardi",
        "marketingName": "mardigras.com",
        "tz": "CST"
    },
    "masslive.com": {
        "name": "mass",
        "marketingName": "masslive.com",
        "tz": "EST"
    },
    "mlive.com": {
        "name": "mlive",
        "marketingName": "MLive.com",
        "tz": "EST"
    },
    "nj.com": {
        "name": "njo",
        "marketingName": "NJ.com",
        "tz": "EST"
    },
    "nola.com": {
        "name": "nola",
        "marketingName": "NOLA.com",
        "tz": "CST"
    },
    "newyorkupstate.com": {
        "name": "nyup",
        "marketingName": "NewYorkUpstate.com",
        "tz": "EST"
    },
    "oregonlive.com": {
        "name": "olive",
        "marketingName": "OregonLive.com",
        "tz": "PST"
    },
    "pennlive.com": {
        "name": "penn",
        "marketingName": "PennLive.com",
        "tz": "EST"
    },
    "silive.com": {
        "name": "silive",
        "marketingName": "silive.com",
        "tz": "EST"
    },
    "syracuse.com": {
        "name": "syr",
        "marketingName": "syracuse.com",
        "tz": "EST"
    },
    "advance.net": {
        "name": "advance",
        "marketingName": "advance.net",
        "tz": "EST"
    }
};

var _siteIds = {
    "production": {
        "al.com": { "default": 352279, "hssn": 352486 },
        "cleveland.com": { "default": 352331, "hssn": 352487 },
        "gulflive.com": { "default": 352332, "hssn": 352332 },  // no hssn gulf id
        "lehighvalleylive.com": { "default": 352333, "hssn": 352488 },
        "mardigras.com": { "default": 352335, "hssn": 352492 }, // HSSN IDs unavailable, using previous nola (?)
        "masslive.com": { "default": 352334, "hssn": 352489 },
        "mlive.com": { "default": 352336, "hssn": 352490 },
        "nj.com": { "default": 352337, "hssn": 352491 },
        "nola.com": { "default": 352338, "hssn": 352492 },
        "newyorkupstate.com":  { "default": 373603, "hssn": 373603 },  // no hssn nyup id
        "oregonlive.com": { "default": 352339, "hssn": 352493 },
        "pennlive.com": { "default": 352340, "hssn": 352494 },
        "silive.com": { "default": 352341, "hssn": 352495 },
        "syracuse.com": { "default": 352342, "hssn": 352496 },
        "advance.net": { "default": 352337, "hssn": 352491 } // njo values, w/e
    },
    "uat": {
        "al.com": { "default": 352500, "hssn": 352501 },
        "cleveland.com": { "default": 352502, "hssn": 352503 },
        "gulflive.com": { "default": 352504, "hssn": 352504 }, // no hssn gulf id
        "lehighvalleylive.com": { "default": 352505, "hssn": 352506 },
        "mardigras.com": { "default": 352499, "hssn": 352514 }, // HSSN IDs unavailable, using previous nola (?)
        "masslive.com": { "default": 352507, "hssn": 352508 },
        "mlive.com": { "default": 352509, "hssn": 352510 },
        "nj.com": { "default": 352511, "hssn": 352512 },
        "nola.com": { "default": 352513, "hssn": 352514 },
        "newyorkupstate.com":  { "default": 373417, "hssn": 373417 },  // no hssn nyup id
        "oregonlive.com": { "default": 352515, "hssn": 352516 },
        "pennlive.com": { "default": 352517, "hssn": 352518 },
        "silive.com": { "default": 352519, "hssn": 352520 },
        "syracuse.com": { "default": 352521, "hssn": 352522 },
        "advance.net": { "default": 352511, "hssn": 352512 } // njo values, w/e
    },
    "dev": {
        "al.com": { "default": 304496, "hssn": 304510 },
        "cleveland.com": { "default": 304497, "hssn": 304511 },
        "gulflive.com": { "default": 304498, "hssn": 304498 }, // no hssn gulf id
        "lehighvalleylive.com": { "default": 304499, "hssn": 304512 },
        "mardigras.com": { "default": 304508, "hssn": 304516 }, //  HSSN IDs unavailable, using previous nola (?)
        "masslive.com": { "default": 304500, "hssn": 304513 },
        "mlive.com": { "default": 304501, "hssn": 304514 },
        "nj.com": { "default": 304502, "hssn": 304515 },
        "nola.com": { "default": 304503, "hssn": 304516 },
        "newyorkupstate.com":  { "default": 305451, "hssn": 305451 },  // no hssn nyup id
        "oregonlive.com": { "default": 304504, "hssn": 304517 },
        "pennlive.com": { "default": 304505, "hssn": 304518 },
        "silive.com": { "default": 304506, "hssn": 304519 },
        "syracuse.com": { "default": 304507, "hssn": 304520 },
        "advance.net": { "default": 304502, "hssn": 304515 } // njo values, w/e
    }
};

window.Advance.Social.context = _getInstance();
module.exports = _getInstance();

});
